// Generated by `npm run data:argo-light` (scripts/data/argoLight.ts) from the
// BGC-Argo extract in data/argo-bgc-par/. Do not edit by hand: change the
// script and run it. tests/light.test.ts builds it again and fails if this
// file is not what the extract gives.

import type { LightShape } from '../../light';

/**
 * How the part of the light's fading that dies with depth, K2 in Lee et
 * al.'s two-part rate (`src/sim/light.ts`), grows with the water's clarity
 * near the top, Kd1 (KdPAR over the first optical depth): K2 = k2AtClear +
 * k2PerKd Kd1, m⁻¹, not held at any floor, by least squares over
 * 859 BGC-Argo light profiles of the 2660 read (M33, review M36; the rest left out by
 * the rules in the script), their Kd1 from 0.020 to 0.600 m⁻¹. MEASURED.
 *
 * Held out (fitted on the even years' 393 profiles; each of the odd years'
 * 466 given its 10% and 1% depths from its Kd1 alone, against its readings):
 *   - oneRate: 10% bias -2.1 m, RMS 7.8 m (466); 1% bias -6.4 m, RMS 22.2 m (459)
 *   - floored: 10% bias 0.0 m, RMS 6.6 m (466); 1% bias 1.5 m, RMS 18.2 m (459)
 *   - unfloored: 10% bias -0.5 m, RMS 5.7 m (466); 1% bias 0.0 m, RMS 15.8 m (459)
 *
 * It keeps the light falling with depth for a clarity from 0.0248 to 0.597 m⁻¹
 * (MEASURED, the build's: `fallingRange`); tests/light.test.ts holds every
 * place the game reads within it.
 */
export const LIGHT_SHAPE: LightShape = { k2AtClear: -0.0694, k2PerKd: 1.434, k2Floor: null };
